/**
 * @param {string} nodeType
 * @param {Document} doc
 * @return {*}
 */
export function injectElement(nodeType, doc = document) {
  return doc.createElement(nodeType);
}
